import type { StateCreator } from 'zustand';

export interface VehicleTourSliceState {
  progressBar: boolean;
  progressBarTitle: string;
  onboardingStepName: string;
  progressBarTourStepsTotal: number;
  vehicleInitialTour: boolean;
  vehicleTourModal: boolean;
  vehicleTour: boolean;
  setVehicleInitialTour: (value: boolean) => void;
  setVehicleTourModal: (value: boolean) => void;
  setVehicleTour: (value: boolean) => void;
  setVehicleTourStart: () => void;
  setVehicleTourFinish: () => void;
}

type StateCreatorVehicleTour = StateCreator<VehicleTourSliceState>;

const initialStates = {
  progressBar: false,
  progressBarTitle: 'Edite seus veículos no painel',
  onboardingStepName: '',
  progressBarTourStepsTotal: 0,
  vehicleInitialTour: false,
  vehicleTour: false,
  vehicleTourModal: false,
};

const createVehicleTourSlice: StateCreatorVehicleTour = (set) => ({
  ...initialStates,
  setVehicleInitialTour: (vehicleInitialTour: boolean) =>
    set({ vehicleInitialTour }),
  setVehicleTourModal: (vehicleTourModal: boolean) => set({ vehicleTourModal }),
  setVehicleTour: (vehicleTour: boolean) => set({ vehicleTour }),
  setVehicleTourStart: () =>
    set({
      ...initialStates,
      progressBar: true,
      onboardingStepName: 'Vehicle',
      progressBarTourStepsTotal: 6,
      vehicleInitialTour: true,
    }),
  setVehicleTourFinish: () =>
    set({
      ...initialStates,
      progressBar: true,
    }),
});

export default createVehicleTourSlice;
